const FetchCurrentTimezoneOffset = {
  mounted() { this.el.value = new Date().getTimezoneOffset() },
}
const FetchCurrentTimezone = {
  mounted() { this.el.value = Intl.DateTimeFormat().resolvedOptions().timeZone},
}
const FetchAndPushCurrentTimezone = {
  mounted() {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.pushEventTo("#"+this.el.id,"set_current_user_timezone", {timezone: tz})
  }
}


export default { FetchCurrentTimezone, FetchCurrentTimezoneOffset, FetchAndPushCurrentTimezone }
